// Imports
import { useMatches } from 'react-router-dom';


/** React hook that detects if the current route is a route for page editors */
export default function useIsPageEditorRoute(): boolean {
	// Use React Router functionality
	const matches = useMatches();
	
	
	// Detect if route is a page editor route
	return matches.some((match) => match.pathname.startsWith('/page-editor'));
}
